export default function diagnosticTestsShop(prices) {
    return {
        prices: [],
        quantities: [],
        totalPrice: 0,
        totalQuantity: 0,
        init() {
            this.prices = prices.map((price) => parseFloat(price));
            this.quantities = prices.map(() => 0);
            this.$watch('quantities', () => {
                const { quantity, price } = this.prices.reduce(
                    (prev, curr, index) => ({
                        quantity: prev.quantity + this.quantities[index],
                        price: prev.price + this.quantities[index] * this.prices[index],
                    }),
                    { quantity: 0, price: 0 }
                );
                this.totalQuantity = quantity;
                this.totalPrice = price;
            });
        },
        // cart: {},
        // items: 0,
        // price: 0,
        // init: function () {
        //     for (const [id, price] of Object.entries(tests)) {
        //         this.cart[id] = { price, quantity: 0 };
        //     }
        //     this.$watch('cart', () => {
        //         const [items, price] = Object.values(this.cart).reduce(
        //             (acc, { price, quantity }) => ({
        //                 items: acc.items + quantity,
        //                 price: acc.price + quantity * price,
        //             }),
        //             { items: 0, price: 0 }
        //         );
        //         this.items = items;
        //         this.price = price;
        //     });
        // },
    };
}
